import { INCOME_BG } from 'assets/images'
import styled from 'styled-components'

export const ButtonSyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const UpgradeGuildContainer = styled.div`
display: flex;
justify-content: center;
align-items: center;
min-height: 40vh;
padding-top: 40px;
position: relative;

p {
  text-transform: uppercase;
  background: linear-gradient(90deg, #ffd901 0%, #fd6401 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 30px;
}

.btn-buy{
  display: flex;
  align-items: center;
  gap: 8px;
  &.scale-down{
    font-size: 14px;
  }
}

.form-content {
  min-height: 400px;
  background: url(${INCOME_BG});
  background-repeat: round;
  color: white;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 0px;
  .max-level {
    gap: 0px !important;
    .present {
      max-width: 70px !important;
      min-width: 70px !important;
    }
  }
  .row-value {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 48px;
    .title{
      min-width: 400px;
      font-size: 20px;
      font-weight: 500;
    }
    .present, .arrow, .next {
      font-size: 18px;
      font-weight: 600;
      text-transform: uppercase;
      min-width: 150px;
      text-align: center;
    }
    .present {
      color: rgb(78, 240, 118);
    }
    .next {
      color: rgb(255, 122, 0);
    }
    .arrow {
      color: rgb(78, 240, 118);
    }
    .visible-hidden {
      visibility: hidden;
    }
    .text-start {
      text-align: start;
    }
    .guild-name {
      font-size: 20px;
      max-width: 150px !important;
      word-break: break-word;
    }
  }
  .row-content {
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%)
  }
  .income-row {
    margin-bottom: 40px;
    align-items: center;
    position: relative;
    width: 100%;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    &.disabled {
      .input-box {
        span,
        input,
        .percent {
          color: #9d9d9d;
        }
      }
    }

    span {
      display: inline-block;
      color: #9d9d9d;
      font-size: 16px;
      text-transform: uppercase;

      &:last-child {
        background: #30343f;
        padding: 4px 30px;
        border: 1px solid #9c9c9c;
        min-width: 99px;
        text-align: center;
        display: inline-block;
      }

      &.requied {
        color: #e01621;
        border: none;
        background: transparent;
        min-width: 10px;
        padding: 0;
      }
    }
  }
}

.button-edit {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px 0px 16px 0px;
  gap: 60px;
}

.error {
  color: #e01621;
  font-size: 18px;
  text-align: center;
}

.ant-spin-dot-item {
  background-color: #4ef076 !important;
}

.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
  background: #fff;
  border-color: #252B43;
}

.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus {
  border-color: #ff4d4f;
  box-shadow: none;
}
.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
  border-color: #ff4d4f;
}
.align-items-center {
  height: 300px
}
.search-input {
  font-size: 19px;
  line-height: 25px;
  height: 250px !important;
}

.guild__textarea {
  color: #f47351;
}
`

export default UpgradeGuildContainer
